<template lang="pug">
  v-select(
    :value="value"
    :items="items"
    :loading="loading"
    :disabled="disabled"
    :menu-props="menuProps"
    :class="['e-unified-select', customClass]"
    :data-test="dataTest"
    solo
    flat
    hide-details
    v-bind="$attrs"
    v-on="listeners"
  )
    template(v-slot:append)
      e-svg-icon(name="arrow-down")
    template(v-slot:item="{ item }")
      div(:class="{ 'e-unified-select__danger-item': item.isDanger }") {{ item.text }}
</template>

<script>
export default {
  name: 'EUnifiedSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    dataTest: {
      type: String,
      default: ''
    },
    menuProps: {
      type: Object,
      default: () => ({ bottom: true, offsetY: true })
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => {
          this.$emit('input', value)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.e-unified-select {
  ::v-deep {
    .v-select__selections {
      padding: 0;
      text-align: right;
      flex-direction: row-reverse;
    }
    .v-select__selection {
      color: $dark2;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
    }
    .v-input__append-inner {
      margin-top: 0;
      margin-left: 4px;
      padding-left: 0;
      svg {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        stroke-width: 1.5px;
        stroke: $dark;
        transition: transform 0.3s ease;
      }
    }
    &.v-input--is-focused,
    &.v-select--is-menu-active {
      .v-input__append-inner {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  &__danger-item {
    color: $danger !important;
  }
}
</style>
